import { render, staticRenderFns } from "./EventCover.vue?vue&type=template&id=490e6cf0&scoped=true"
import script from "./EventCover.vue?vue&type=script&lang=js"
export * from "./EventCover.vue?vue&type=script&lang=js"
import style0 from "./EventCover.vue?vue&type=style&index=0&id=490e6cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e6cf0",
  null
  
)

export default component.exports